(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.slick = {
    attach: function (context, settings) {

      // See http://kenwheeler.github.io/slick/#settings

    }
  };

})(jQuery, Drupal, this, this.document);
